export default __webpack_public_path__ + "static/media/bodymedia-innovationdays.a9c26937.svg";